// app/javascript/src/layouts/SettingsLayout/SettingsNavigationProvider.stories.tsx
import React from "react";
import { MemoryRouter } from "react-router-dom";
import SettingsNavigationProvider from "./SettingsNavigationProvider";

export default {
  title: "Layouts/SettingsNavigationProvider",
  component: SettingsNavigationProvider,
};

// useWhoAmIQuery hits the RTK store; in Storybook without a provider it returns
// undefined data, so the Site Admin section stays hidden — which is the
// intended non-site-admin view for this story.
export const Default = () => (
  <MemoryRouter initialEntries={["/admin/sections"]}>
    <div style={{ height: 200 }}>
      <SettingsNavigationProvider sidebarWidth={240} />
    </div>
  </MemoryRouter>
);
